import { getOhsLocalStorage, SsoFlagName } from 'global-services/OhsDataParse';
import { OhsModule, ModuleType } from 'global-services/constants/OhsObject';
import { FreemiumOrgId } from 'global-services/constants/OhsConstants';
import { OhsTier } from 'global-services/constants/tier/OhsTier';
import OhsQrCodeRecord from 'qr-code/models/OhsQrCodeRecord';

import OhsConfigurations from './configurations/OhsConfigurations';
import manipulateGuestUserConfig from './configurations/OhsManipulateConfiguartion';

export class OhsUser implements OhsModule {
  type!: ModuleType;

  _id!: string;

  name!: string;

  email!: string;

  phone: string | null = null;

  phoneCountryCode: string | null = null;

  isGuest: boolean = false;

  tier!: OhsTier;

  orgAdmin: OhsTier | null = null;

  org: OhsTier | null = null;

  workplace: OhsTier | null = null;

  workerGroup: OhsTier | null = null;

  isMorph: boolean = false;

  morphType: OhsUserMorphType = 'None';

  isSso: boolean = false;

  isMultiUser: boolean = false;

  tierNum!: number;

  level: OhsUserPlanType = 'paid';

  configs: OhsConfigurations;

  mfa?: OhsMFAsettings;

  qrCodeDataConfig: OhsQrCodeRecord | null = null;

  constructor(userPayload: any) {
    this.type = userPayload?.type;
    this.configs = new OhsConfigurations(userPayload.configuration);
    this.tier = new OhsTier(userPayload.tier);
    this.tierNum = parseInt(this.tier.type.substring(11), 10);
    if (this.type === ModuleType.GuestUser) {
      this.guestUserConstructor(userPayload);
    } else if (this.type === ModuleType.User && userPayload?.user) {
      this.normalUserConstructor(userPayload);
    }
  }

  guestUserConstructor(userPayload: any) {
    this._id = userPayload?._id ?? '';
    this.name = userPayload?.name ?? 'Guest';
    this.email = userPayload?.email ?? '';
    this.phone = userPayload?.phone ?? null;
    this.phoneCountryCode = userPayload?.phoneCountryCode ?? null;
    this.isGuest = userPayload?.isGuest ?? true;
    this.qrCodeDataConfig = userPayload?.qrCodeDataConfig ?? null;

    if (this.qrCodeDataConfig && this.qrCodeDataConfig?._id) {
      manipulateGuestUserConfig(this.configs, this.qrCodeDataConfig);
    }
  }

  normalUserConstructor(userPayload: any) {
    const payload = userPayload.user;

    this._id = payload._id;
    this.name = payload.name;
    this.email = payload.email;

    if (payload.orgAdmin?._id) this.orgAdmin = payload.orgAdmin;
    if (payload.org?._id) this.org = payload.org;
    if (payload.workplace?._id) this.workplace = payload.workplace;
    if (payload.workerGroup?._id) this.workerGroup = payload.workerGroup;

    if (this.orgAdmin && this.orgAdmin._id === FreemiumOrgId) {
      this.level = 'free';
    }

    this.isMorph = payload?.morph === true;
    if (this.isMorph) {
      if (this.tierNum === 2) this.morphType = 'Up';
      else if (this.tierNum === 4) this.morphType = 'Down';
    }

    const isSso = getOhsLocalStorage(SsoFlagName);
    this.isSso = isSso === true;

    this.isMultiUser = payload?.multiuser === true;
  }
}

export interface OhsMFAsettings {
  enabled: boolean;
  method: string;
}

export interface OhsMfaMethodSettings {
  app: boolean;
  sms: boolean;
  email: boolean;
}
export { SsoFlagName };

export type OhsUserMorphType = 'None' | 'Up' | 'Down';

export type OhsUserPlanType = 'paid' | 'free';

export type OhsUserLoginType = 'Azure SSO' | 'Username Password';
